import React, { useState, useEffect } from 'react';
import { StatelessAccordion, Panel } from 'baseui/accordion';
import _isEmpty from 'lodash/isEmpty';

interface AccordianPropsInterface {
	children: any;
	label: string | React.ReactElement;
	panelKey: string;
	isCollapsed: boolean;
	setIsCollapsed: (isCollapsed: boolean) => void;
}

const Accordian: React.FC<AccordianPropsInterface> = (props) => {
	const { children, label, panelKey, isCollapsed, setIsCollapsed } = props;
	const [expanded, setExpanded] = useState<Array<React.Key>>(isCollapsed ? [] : [panelKey]);

	useEffect(() => {
		setExpanded(isCollapsed ? [] : [panelKey]);
	}, [isCollapsed]);

	return (
		<StatelessAccordion
			onChange={({ expanded: panelExpanded }) => {
				setIsCollapsed(_isEmpty(panelExpanded));
			}}
			expanded={expanded}>
			<Panel
				key={panelKey}
				title={label}
				overrides={{
					PanelContainer: {
						style: {
							borderBottomColor: '#eeeeee'
						}
					},
					Content: {
						style: {
							paddingTop: '2px !important',
							paddingRight: '0px !important',
							paddingBottom: '2px !important',
							paddingLeft: '10px !important',
							fontSize: '1em',
							backgroundColor: '#ffffff'
						}
					},
					Header: {
						style: {
							flexDirection: 'row-reverse',
							justifyContent: 'left',
							gap: '10px',
							paddingTop: '10px',
							paddingBottom: '10px'
						}
					}
				}}>
				{children}
			</Panel>
		</StatelessAccordion>
	);
};

export default Accordian;
